module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow-b1109773a085619db24571b485c734b4.png";